import { render, staticRenderFns } from "./StandardDrawer.vue?vue&type=template&id=408e118e&scoped=true"
import script from "./StandardDrawer.vue?vue&type=script&lang=js"
export * from "./StandardDrawer.vue?vue&type=script&lang=js"
import style0 from "./StandardDrawer.vue?vue&type=style&index=0&id=408e118e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408e118e",
  null
  
)

export default component.exports